import React from 'react';
import { BarChart3, TrendingUp, Users, Clock } from 'lucide-react';
import { MetricCard } from './MetricCard';
import { useAppStore } from '../../store';
import { calculateMetrics } from '../../utils/analytics';

export const MetricsGrid = () => {
  const tasks = useAppStore((state) => state.tasks);
  const teams = useAppStore((state) => state.teams);
  
  const metrics = calculateMetrics(tasks, teams);

  const metricsData = [
    {
      title: 'Task Completion Rate',
      value: `${metrics.taskCompletionRate}%`,
      change: '+12%',
      description: 'vs last month',
      icon: BarChart3,
      isPositive: true
    },
    {
      title: 'Team Productivity',
      value: `${metrics.teamProductivity}%`,
      change: '+7%',
      description: 'vs last month',
      icon: TrendingUp,
      isPositive: true
    },
    {
      title: 'Active Team Members',
      value: `${metrics.activeMembers}/${teams.reduce((acc, team) => acc + team.members.length, 0)}`,
      change: '+2',
      description: 'new this month',
      icon: Users,
      isPositive: true
    },
    {
      title: 'Average Response Time',
      value: `${metrics.averageResponseTime}h`,
      change: '-18%',
      description: 'vs last month',
      icon: Clock,
      isPositive: true
    }
  ];

  return (
    <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
      {metricsData.map((metric) => (
        <MetricCard key={metric.title} {...metric} />
      ))}
    </div>
  );
};